import { render } from "./ChoicePostLogin.vue?vue&type=template&id=4a74f77c"
import script from "./ChoicePostLogin.vue?vue&type=script&lang=js"
export * from "./ChoicePostLogin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__